import { MrToggle } from '@level-level/recyclops';
import { IOptions } from '@level-level/recyclops/types/mr-toggle';
import { IModule } from '../globals';

class Toggle implements IModule {
	element: HTMLElement;
	config: {
		trigger: string | null;
		target: string | null;
		disableScroll: boolean;
		disableTrap: boolean;
		customScrollableElement: string | null;
		focusInputClass?: string | null;
		focusInput: boolean;
		defaultButtonText?: string | null;
		closeButtonText?: string | null;
		isChildToggle?: boolean;
		collapseExpand?: boolean;
	};

	constructor(element: HTMLElement) {
		this.element = element;
		this.config = this.element.dataset.config
			? JSON.parse(this.element.dataset.config)
			: {};

		this.initialize();
	}

	initialize() {
		const options: IOptions = {
			moduleName: 'toggle',
			useHover: false,
		};

		new MrToggle(this.element, options);

		if (this.config.collapseExpand) {
			this.element.addEventListener('openMrToggle', this.expandDropdown);
			this.element.addEventListener('closeMrToggle', this.collapseDropdown);
		}
	}

	collapseDropdown = () => {
		if (!this.config.target) return;

		const dropDown = document.querySelector<HTMLElement>(this.config.target);

		if (!dropDown) return;

		dropDown.style.maxHeight = '0px';
	};

	expandDropdown = () => {
		if (!this.config.target) return;

		const dropDown = document.querySelector<HTMLElement>(this.config.target);

		if (!dropDown) return;

		const height = dropDown.scrollHeight;
		dropDown.style.maxHeight = `${height}px`;
	};
}

export default Toggle;
